import { Webhook as SvixWebhook } from "svix";

import { Client } from "../client";
import {
  WebhookRegisterOptions,
  WebhookRegisterResponse,
  WebhookVerifyOptions,
} from "../interfaces";

export class Webhook {
  private client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  /**
   * It takes in an object, makes a POST request to the /webhook endpoint, and returns the response data
   * @param {WebhookRegisterOptions} options - WebhookOptions
   */
  async register(
    options: WebhookRegisterOptions
  ): Promise<WebhookRegisterResponse> {
    try {
      const response = await this.client.post(`/webhook`, options);

      return response.data;
    } catch (err) {
      throw new Error(err);
    }
  }

  /**
   * A helper function to verify the webhook's signature in the headers
   */
  async verify(options: WebhookVerifyOptions) {
    const svixWebhook = new SvixWebhook(options.webhook_secret);
    try {
      await svixWebhook.verify(options.payload, options.headers);
    } catch (err) {
      throw new Error("Invalid webhook signature");
    }
  }
}
